import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef,
  ComponentRef
} from '@angular/core';
import { from, Observable, Subject, of } from 'rxjs';
import { RewardsToasterComponent } from '../../components/rewards/rewards-toaster/rewards-toaster.component';
import { RewardsToasterData, RewardsToasterEvent, RewardsToasterOption } from './rewards-toaster.interface';

@Injectable({
  providedIn: 'root',
})
export class RewardsToasterService {
  public static autoCloseTime = 9000;
  private eventSubject = new Subject<RewardsToasterEvent>();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }

  createToast(data: RewardsToasterData, continueCb: () => void, closeCb: () => void, isInModal: boolean): HTMLElement {
    // create a component reference from the component
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(RewardsToasterComponent)
      .create(this.injector);
    // pass data
    componentRef.instance.data = data;
    // styles based on context
    let options: RewardsToasterOption = isInModal ? {} : {};
    componentRef.instance.options = options;
    // open modal after miliseconds
    setTimeout(() => {
      componentRef.instance.isOpen = true;
    })

    // process events
    componentRef.instance.toasterEvents.subscribe(event => {
        // TODO update subject in here based on val
      switch(event.type) {
        case 'continue': {
          of(continueCb()).subscribe(_ => {
            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();
          });
          break;
        }
        case 'close': {
          closeCb();
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
          break;
        }
      }
    });

    // Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(componentRef.hostView);

    // Get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    // return {toast: domElem, event: this.eventSubject.asObservable()};
    return domElem;
  }
}
